/** U+2028 / U+2029: valid in JSON, but they end a line in older JavaScript parsers. */
const LINE_SEPARATORS = new RegExp("[\\u2028\\u2029]", "g");

/**
 * JSON-LD for a `<script type="application/ld+json">`. `JSON.stringify` leaves `<`, `>`
 * and `&` alone, so a value holding `</script>` (a search's `address_name`, a host's
 * name) would close the tag and run what follows. Escaped as `\u…`, the JSON reads the
 * same.
 */
export const jsonLdService = {
  serialize(schema: unknown): string {
    return JSON.stringify(schema)
      .replace(/</g, "\\u003c")
      .replace(/>/g, "\\u003e")
      .replace(/&/g, "\\u0026")
      .replace(
        LINE_SEPARATORS,
        (c) => `\\u${c.charCodeAt(0).toString(16).padStart(4, "0")}`,
      );
  },
};
